
import React from 'react';

export default function ActionItemInformationPage1() 
{
    return ( 
        <> 
            <p>This is where things get interesting...</p>

            <p>Emails, SMS messages, Live Chats are basically fire-and-forget. If an Action is passed this way a person must make a note
            to follow up ... which can be less than efficient.</p>

            <p>In a traditional punch list, an entry is just an item to be checked off. It might have an assignee, due-date, simple state, etc.
            which is better than the first options but they are often owned by one Team Member who is responsible for making all updates.</p>

            <p>Here an Action can be much more. It carries all of the traditional information but it can also store pertinent file attachments.
            Any Team Member can record their reaction and/or add comments with their inputs/feedback. And those comments can also include
            their own file attachments.</p>

            <p>These features along with its own Action History can be very powerfull, especially if business demands require an Action be stopped 
            and started more than once. Actions may also require input from more than one Team Member (ex. is reassigned by the Action assignee to
            another Team Member to continue or for verification).</p>

            <p>Actions condense all relevant information and Team communication in one place ... well actually, 3+ geographically 
            distant data-centers to ensure business continuity, but that's just details :) </p>
        </> 
    );
}
